import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import { CurrentUserFragment as User } from '../../gen/graphql';
import { useNavigate } from 'react-router-dom';
import UserType from '../../const/UserType';
import { CircularIcon } from '../atoms/CircularIcon';

interface VerticalUserInfoProps {
  user?: User;
}

export const VerticalUserInfo: React.FC<VerticalUserInfoProps> = (props) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (props.user?.id) {
      navigate(`/users/${props.user.id}/profile`);
    }
  };
  return (
    <Container>
      <StyledCircularIcon
        size={40}
        src={props.user?.image}
        onClick={handleClick}
        userType={
          props.user?.isInstructor
            ? UserType.Instructor
            : props.user?.isStudent
              ? UserType.Student
              : UserType.SnsUser
        }
      />
      <Name>{props.user?.personalInfo?.name || 'ゲスト'}</Name>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Name = styled.p`
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.87);
  text-align: center;
  margin-top: 4px;
`;

const StyledCircularIcon = styled(CircularIcon)`
  width: 40px;
  height: 40px;
  img {
    cursor: default;
  }

  .crown_icon {
    width: 16px !important;
    height: 16px !important;
    right: 0;
    bottom: 0;
  }

  ${media.lessThan('medium')`
    width: 32px;
    height: 32px;
  `}
`;
